import React, { useEffect, useRef } from "react";
import "./ringsShop.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Ring_1 from "./images/ring_1.webp";
import Ring_2 from "./images/ring_2.webp";
import Ring_3 from "./images/ring_3.webp";
import Ring_4 from "./images/ring_4.webp";
import Ring_5 from "./images/ring_5.webp";
import ShopIcon from "../../../images/shop.svg";

import Video1 from "./images/video_1.mp4";

export default function RingsShop() {
  return (
    <div className="ringsShop-main">
      <div className="ringsShop-container">
        <video
          playsinline="true"
          autoplay="true"
          loop="true"
          muted="true"
          className="ringsShop-element ringsShop-video"
        >
          <source
            src="https://cdn.media.amplience.net/v/teilor/inel (2)/mp4_720p"
            type="video/mp4"
          />
        </video>
        <div className="ringsShop-element ringsShop-product-1">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/pierscionek-z-18-karatowego-bialego-zlota-z-3-02-karatowymi-diamentami-108429.html"
          >
            <img
              className="zoom"
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/piercionek-z-18karatowego-biaego-zota-z-302karatowymi-diamentami_2489476_1_1648709573.png"
              }
              alt=""
            />
            <img className="shop-icon" src={ShopIcon} alt="" />
          </a>
        </div>
        <div className="ringsShop-element ringsShop-product-2">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/pierscionek-z-bialo-zoltego-zlota-18-karatowego-z-przezroczystymi-diamentami-1-05ct-i-0-58-karatowym-zoltym-diamentem-122809.html"
          >
            <img
              className="zoom"
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/piercionek-z-biaotego-zota-18karatowego-z-przezroczystymi-diamentami-105ct-i-058karatowym-tym-diamentem_3099026_1_1653919979.png"
              }
              alt=""
            />
            <img className="shop-icon" src={ShopIcon} alt="" />
          </a>
        </div>
        <div className="ringsShop-element ringsShop-product-3">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/pierscionek-z-bialego-zlota-18k-z-diamentami-1-18ct-115383.html"
          >
            <img
              className="zoom"
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/piercionek-z-biaego-zota-18k-z-diamentami-118ct_3113244_1_1653919978.png"
              }
              alt=""
            />
            <img className="shop-icon" src={ShopIcon} alt="" />
          </a>
        </div>
        <div className="ringsShop-element ringsShop-product-4">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/pierscionek-z-18k-bialego-zlota-z-14-15ct-tanzanitem-i-0-5ct-diamentami-116056.html"
          >
            <img
              className="zoom"
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/piercionek-z-18k-biaego-zota-z-1415ct-tanzanitem-i-05ct-diamentami_3096798_1_1653917620.png"
              }
              alt=""
            />
            <img className="shop-icon" src={ShopIcon} alt="" />
          </a>
        </div>
        <div className="ringsShop-element ringsShop-product-5">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/pierscionek-z-bialego-zlota-18k-z-diamentami-2-62ct-107086.html"
          >
            <img
              className="zoom"
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/piercionek-z-biaego-zota-18k-z-diamentami-262ct_2488302_1_1653919978.png"
              }
              alt=""
            />
            <img className="shop-icon" src={ShopIcon} alt="" />
          </a>
        </div>
      </div>
      <div className="component-button">
        <div className="component-button-border"></div>
        <div className="component-button-text">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/pure-diamonds/filtre/rodzaj-bizuterii-pierscionk/rodzaj-bizuterii-pierscionek-zareczynowy.html"
          >
            ODKRYJ PIERŚCIONKI
          </a>
        </div>
      </div>
    </div>
  );
}
